import type React from 'react';

import { SkeletonContainer } from 'src/app/pages/starterDashboardV2/shared/components';

import { PlatformCardSkeleton } from './components/PlatformCardSkeleton';

export const RecommendedGroupsCardLoading: React.FC = () => {
	return (
		<div className="flex h-full w-full items-center justify-center gap-4">
			<SkeletonContainer loading>
				<PlatformCardSkeleton platform="reddit" placeholderColor="bg-fill-disabled" />
			</SkeletonContainer>
			<SkeletonContainer loading>
				<PlatformCardSkeleton platform="facebook" placeholderColor="bg-fill-disabled" />
			</SkeletonContainer>
		</div>
	);
};
